/**
 * Utility class for saving data as an XMD file.
 * @category Components
 * @subcategory XmdManager
 */

export default class XmdSaver {
  /**
   * Saves the given data as an XMD file with a properly formatted filename.
   *
   * @param {Object} data - The data to be saved, serialized as JSON.
   * @param {string} [filenameElementId='toolbar-project-name'] - The ID of the document element
   *   used to retrieve the filename. Defaults to 'toolbar-project-name'.
   *
   * The method ensures that the filename is non-empty and has the `.xmd` extension. If the specified
   * filename is empty or consists only of whitespace, it defaults to 'design.xmd'. If the `.xmd`
   * extension is missing, it appends it automatically.
   */

  static saveAsXmd(data, filenameElementId = "toolbar-project-name") {
    const xmdData = JSON.stringify(data, null, 2);
    const blob = new Blob([xmdData], { type: "application/xmd" });
    const filenameElement = document.getElementById(filenameElementId);
    let filename =
      filenameElement && filenameElement.value.trim()
        ? filenameElement.value.trim()
        : "design";

    if (!filename.toLowerCase().endsWith(".xmd")) {
      filename += ".xmd";
    }

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  static cleanup() {
    console.log(`✅ Cleaning up XmdSaver...`);

    // Revoke any created object URLs to free up memory
    if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
    }

    console.log(`✅ XmdSaver cleanup complete.`);
}
}
